export default __webpack_public_path__ + "static/media/slack.b336b629.svg";